import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom';
import { skipToken } from '@reduxjs/toolkit/query/react'
import Style from '../styles/pages/Reservation.module.scss'
import { Link, useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import PageHeader from '../components/layout/PageHeader'
import { Box, Typography, List, ListItem , Avatar} from '@mui/material'
import arrow from '../shared/images/arrow-down.svg'
import { RootState } from '../store/GlobalStore'
import { useGetUserReservationQuery} from '../services/ReservationAPI'
import { environment } from '../utils/Environment'
import { Reservation } from '../utils/Interface'
import { useTranslation } from 'react-i18next';
const ReservationsPage: React.FC = () => {
    const authState = useSelector((state: RootState) => state.Auth)
    const { id } = useParams<{ id: string }>();
     // Ne pas appeler la query si l'utilisateur n'est pas défini
     const userEmail = authState?.user?.email
     const [reservationData, setReservationData] = useState<Reservation>();
     const [activeTab, setActiveTab] = useState<'incoming' | 'past'>('incoming');
     const { t } = useTranslation();

    useEffect(() => {
        if (authState?.reservations !== null) {
            const data = authState?.reservations;
            console.log("id   ====> " + id)
            // Filtrer la réservation spécifique par son ID
            const updatedData = data.map(reservation => ({
                ...reservation,
                Bookings: reservation.Bookings.map(booking => ({
                    ...booking,
                    // Si forfaitCode est manquant, essayez de le retrouver
                    forfaitCode: (booking.forfaitCode === '') ? getForfaitCode(reservation.Bookings, booking.ressourceTypeCode) : booking.forfaitCode
                }))
            }));


            const specificReservation = updatedData.find(reservation => Number(reservation.asterioId) === Number(id));
            console.log(data)

            
            if (specificReservation !== undefined) {

                /*specificReservation.Bookings.map(booking => ({
                    ...booking,
                    // Si forfaitCode est manquant, essayez de le retrouver
                    forfaitCode: booking.forfaitCode || getForfaitCode(specificReservation.Bookings, booking.ressourceTypeCode)
                }));
                console.log(specificReservation)*/
                setReservationData(specificReservation);
            }
        }
    }, [authState?.reservations, id, activeTab]);

    const getForfaitCode = (bookings : any, ressourceTypeCode : string) => {
        console.log(ressourceTypeCode)
        const similarBooking = bookings.find(
            (booking : any) => booking.ressourceTypeCode === ressourceTypeCode  && booking.forfaitCode && booking.forfaitCode !== ''
        );
        return similarBooking ? similarBooking.forfaitCode : null;
    };
    
    return (
        <div className={Style.MainContainer}>
            <PageHeader backTo='/all-reservations' title='Hébergements' subtitle='Retrouvez les informations liées à votre réservation' />
            
            <div className={Style.FullWidthWrapper}>
        
                {reservationData && (
                    <div className={Style.InfoCardFullWidth}>
                        <div className={Style.InfoLeft}>
                            <span className={Style.LieuTag}>Les Settons</span>
                            <p className={Style.DateText}>
                                Du {new Date(reservationData.Bookings[0].startDate).toLocaleDateString('fr-FR')} au {new Date(reservationData.Bookings[0].endDate).toLocaleDateString('fr-FR')}
                            </p>
                        </div>
                        <div className={Style.InfoRight}>
                            <span className={Style.ResaBadge}>N° {reservationData.asterioId}</span>
                        </div>
                    </div>
                )}

                <div className={Style.AccommodationGrid}>
                    {reservationData?.Bookings.map((booking, index) => (
                        <Link 
                            key={index} 
                            to={`/booking/${booking.bookingId}`} 
                            className={Style.GridItem}
                        >
                            <div className={Style.CardContent}>
                                <img
                                    src={`${process.env.REACT_APP_BASE_URL}${booking.displayImage}`}
                                    alt="Hébergement"
                                    className={Style.CardImage}
                                />
                                <div className={Style.CardText}>
                                    <p className={Style.Category}>Les Settons</p>

                                     <h4 className={Style.TypeTitle}>{booking.ressourceTypeLabel}</h4>
                                    <p className={Style.Details}>{booking.nbAdults} ad. - {booking.nbChilds} enf.</p>
                                    
                                    
                                    <p className={Style.Price}>
                                        {reservationData.Folios.find(f => f.productCode === booking.forfaitCode)?.unitPrice} € / nuit
                                    </p>
                                </div>
                            </div>
                            <img src={arrow} alt="arrow" className={Style.Arrow} />
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
        
}

export default ReservationsPage